/**
 * The "Not called" tag: a small pill in the foreground colour on the page
 * background. It stands in for the share bar of a task none of whose tools
 * was called in the window, and the note is its tooltip.
 */

import { Tooltip, TooltipTrigger } from '@/components/ui/tooltip'

import { TipContent } from '@/components/shared/InfoTip'

export const NOT_CALLED_LABEL = 'Not called'

export function NotCalledTag({ note }: { note: string }): React.JSX.Element {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span
          data-tag="not-called"
          tabIndex={0}
          className="inline-flex items-center rounded-full border border-foreground bg-background px-2 py-px text-[11px] font-medium leading-4 text-foreground cursor-help"
        >
          {NOT_CALLED_LABEL}
        </span>
      </TooltipTrigger>
      <TipContent text={note} />
    </Tooltip>
  )
}
